import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { hasAnyPermission, hasPermission, isRestrictedVendor } from '../utils/permissions';

/**
 * ProtectedRoute Component
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({
  children,
  resource,
  action = 'read',
  anyPermissions,
  hideForVendor = false,
}) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (hideForVendor && isRestrictedVendor(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  const hasRequiredPermission = anyPermissions
    ? hasAnyPermission(user, anyPermissions)
    : hasPermission(user, resource, action);

  if ((resource || anyPermissions) && !hasRequiredPermission) {
    return (
      <div className="loading-container">
        You do not have permission to view this page.
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
